import { APITypes } from '../../primary-record-types';
import { appAPI } from '../api';
import urls from '../urls';

/**
 * Post one batch of events.
 *
 * The route answers 202 for anything Firehose accepted and reports permanent failures in the body rather
 * than as an error status, so a retry here could only duplicate records that already landed — nothing
 * downstream deduplicates by eventId. Hence no-retry, overriding the client's default backoff.
 */
export const sendAnalyticsEvents = async (events: APITypes.analyticsService.AnalyticsEventInput[]) => {
    const body: APITypes.analyticsService.RecordAnalyticsEventsRequest = { events };

    await appAPI.post<APITypes.analyticsService.RecordAnalyticsEventsResponse>(urls.api.analytics.events, {
        body,
        retryStrategy: { strategy: 'no-retry' },
    });
};
